import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './sections/HeroSection';
import { PainIdentificationSection } from './sections/PainIdentificationSection';
import { DeepFearsSection } from './sections/DeepFearsSection';
import { ProductDescriptionSection } from './sections/ProductDescriptionSection';
import { ContentsSection } from './sections/ContentsSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { AudienceSection } from './sections/AudienceSection';
import { FAQSection } from './sections/FAQSection';
import { PricingSection } from './sections/PricingSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { PopNotification } from './components/PopNotification';
import { MobileBanner } from './components/MobileBanner';
import { LegalModal } from './components/LegalModal';
type LegalModalType = 'terminos' | 'privacidad' | 'cookies' | 'reembolsos' | null;
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  const [activeModal, setActiveModal] = useState<LegalModalType>(null);
  useEffect(() => {
    document.title = 'Desconexión Emocional';
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1287893343258066');
    window.fbq('track', 'PageView');
  }, []);
  const renderModalContent = () => {
    switch (activeModal) {
      case 'terminos':
        return <div className="space-y-4" data-id="element-0">
            <p className="text-xs text-gray-500 mb-4" data-id="element-1">
              Última actualización: 12 de marzo de 2026
            </p>
            <h3 className="text-lg font-bold text-warmBrown font-heading" data-id="element-2">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-3">
              Al acceder y utilizar este sitio web y adquirir nuestros productos
              digitales, usted acepta estar sujeto a estos Términos y
              Condiciones. Si no está de acuerdo con alguna parte de estos
              términos, no debe utilizar nuestros servicios.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-4">
              2. Descripción del Producto
            </h3>
            <p data-id="element-5">
              "Desconexión Emocional" es un producto digital en formato PDF que
              incluye:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-6">
              <li data-id="element-7">Guía completa en formato PDF descargable</li>
              <li data-id="element-8">Acceso inmediato tras la confirmación del pago</li>
            </ul>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-9">
              3. Propiedad Intelectual
            </h3>
            <p data-id="element-10">
              Todo el contenido de este ebook, incluyendo textos, gráficos,
              logotipos e imágenes, es propiedad exclusiva de los autores y está
              protegido por las leyes internacionales de derechos de autor.
              Queda estrictamente prohibida su reproducción, distribución,
              reventa o modificación sin autorización previa por escrito.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-11">
              4. Limitación de Responsabilidad
            </h3>
            <p data-id="element-12">
              Este ebook proporciona información educativa y de autoayuda. No
              sustituye el consejo, diagnóstico o tratamiento de un profesional
              de la salud mental o terapeuta de parejas. Los resultados pueden
              variar según la situación individual de cada persona.
            </p>
          </div>;
      case 'privacidad':
        return <div className="space-y-4" data-id="element-13">
            <p className="text-xs text-gray-500 mb-4" data-id="element-14">
              Última actualización: 12 de marzo de 2026
            </p>
            <h3 className="text-lg font-bold text-warmBrown font-heading" data-id="element-15">
              1. Recopilación de Información
            </h3>
            <p data-id="element-16">
              Recopilamos información personal que usted nos proporciona
              voluntariamente al realizar una compra, como su nombre, dirección
              de correo electrónico y detalles de pago (procesados de forma
              segura a través de nuestros proveedores de pago).
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-17">
              2. Uso de la Información
            </h3>
            <p data-id="element-18">Utilizamos su información para:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-19">
              <li data-id="element-20">Procesar sus transacciones y entregar el producto digital</li>
              <li data-id="element-21">Enviar correos electrónicos relacionados con su compra</li>
              <li data-id="element-22">Proporcionar soporte al cliente</li>
              <li data-id="element-23">Mejorar nuestros productos y servicios</li>
            </ul>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-24">
              3. Protección de Datos
            </h3>
            <p data-id="element-25">
              Implementamos medidas de seguridad para mantener la seguridad de
              su información personal. No vendemos, intercambiamos ni
              transferimos a terceros su información personal identificable.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-26">
              4. Sus Derechos
            </h3>
            <p data-id="element-27">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal en cualquier momento poniéndose en contacto con nuestro
              equipo de soporte.
            </p>
          </div>;
      case 'cookies':
        return <div className="space-y-4" data-id="element-28">
            <p className="text-xs text-gray-500 mb-4" data-id="element-29">
              Última actualización: 12 de marzo de 2026
            </p>
            <h3 className="text-lg font-bold text-warmBrown font-heading" data-id="element-30">
              1. ¿Qué son las cookies?
            </h3>
            <p data-id="element-31">
              Las cookies son pequeños archivos de texto que un sitio web guarda
              en su ordenador o dispositivo móvil cuando usted visita el sitio.
              Permiten que el sitio web recuerde sus acciones y preferencias
              durante un período de tiempo.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-32">
              2. Tipos de cookies que utilizamos
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-33">
              <li data-id="element-34">
                <strong data-id="element-35">Cookies esenciales:</strong> Necesarias para el
                funcionamiento básico del sitio web y el proceso de compra.
              </li>
              <li data-id="element-36">
                <strong data-id="element-37">Cookies analíticas:</strong> Nos ayudan a entender cómo
                los visitantes interactúan con el sitio web, recopilando y
                reportando información de forma anónima.
              </li>
              <li data-id="element-38">
                <strong data-id="element-39">Cookies de marketing:</strong> Utilizadas para rastrear
                a los visitantes en los sitios web con el fin de mostrar
                anuncios relevantes.
              </li>
            </ul>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-40">
              3. Gestión de cookies
            </h3>
            <p data-id="element-41">
              Puede controlar y/o eliminar las cookies según lo desee. Puede
              eliminar todas las cookies que ya están en su computadora y puede
              configurar la mayoría de los navegadores para evitar que se
              coloquen. Sin embargo, si hace esto, es posible que tenga que
              ajustar manualmente algunas preferencias cada vez que visite un
              sitio.
            </p>
          </div>;
      case 'reembolsos':
        return <div className="space-y-4" data-id="element-42">
            <p className="text-xs text-gray-500 mb-4" data-id="element-43">
              Última actualización: 12 de marzo de 2026
            </p>
            <h3 className="text-lg font-bold text-warmBrown font-heading" data-id="element-44">
              1. Garantía de Satisfacción
            </h3>
            <p data-id="element-45">
              Ofrecemos una garantía de satisfacción de 7 días para nuestro
              ebook "Desconexión Emocional". Si por alguna razón no está
              satisfecho con el contenido, puede solicitar un reembolso completo
              dentro de los primeros 7 días posteriores a su compra.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-46">
              2. Proceso de Reembolso
            </h3>
            <p data-id="element-47">Para solicitar un reembolso, por favor siga estos pasos:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-48">
              <li data-id="element-49">Envíe un correo electrónico a nuestro equipo de soporte.</li>
              <li data-id="element-50">
                Incluya su número de pedido y la dirección de correo electrónico
                utilizada para la compra.
              </li>
              <li data-id="element-51">
                Indique brevemente el motivo de su solicitud (esto nos ayuda a
                mejorar).
              </li>
            </ul>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-52">
              3. Procesamiento
            </h3>
            <p data-id="element-53">
              Una vez aprobada su solicitud, el reembolso se procesará y se
              aplicará automáticamente a su tarjeta de crédito o método de pago
              original en un plazo de 5 a 10 días hábiles, dependiendo de su
              institución financiera.
            </p>

            <h3 className="text-lg font-bold text-warmBrown font-heading mt-6" data-id="element-54">
              4. Excepciones
            </h3>
            <p data-id="element-55">
              Nos reservamos el derecho de denegar solicitudes de reembolso si
              detectamos un patrón de abuso de nuestra política de devoluciones
              o si la solicitud se realiza después del período de garantía de 7
              días.
            </p>
          </div>;
      default:
        return null;
    }
  };
  const getModalTitle = () => {
    switch (activeModal) {
      case 'terminos':
        return 'Términos y Condiciones';
      case 'privacidad':
        return 'Política de Privacidad';
      case 'cookies':
        return 'Política de Cookies';
      case 'reembolsos':
        return 'Reembolsos y Devoluciones';
      default:
        return '';
    }
  };
  return <div className="min-h-screen font-body text-warmBrown bg-cream selection:bg-softGold/30 pt-10 md:pt-0" data-id="element-56">
      <MobileBanner data-id="element-57" />
      <main data-id="element-58">
        <HeroSection data-id="element-59" />
        <PainIdentificationSection data-id="element-60" />
        <DeepFearsSection data-id="element-61" />
        <ProductDescriptionSection data-id="element-62" />
        <ContentsSection data-id="element-63" />
        <TestimonialsSection data-id="element-64" />
        <AudienceSection data-id="element-65" />
        <FAQSection data-id="element-66" />
        <PricingSection data-id="element-67" />
        <FinalCTASection data-id="element-68" />
      </main>

      <footer className="py-10 bg-[#2D2D2D] text-gray-400 text-sm" data-id="element-69">
        <div className="max-w-4xl mx-auto px-6 flex flex-col items-center gap-6" data-id="element-70">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-gray-300" data-id="element-71">
            <button onClick={() => setActiveModal('terminos')} className="hover:text-white transition-colors" data-id="element-72">
              Términos y Condiciones
            </button>
            <span className="hidden sm:inline" data-id="element-73">|</span>
            <button onClick={() => setActiveModal('privacidad')} className="hover:text-white transition-colors" data-id="element-74">
              Privacidad
            </button>
            <span className="hidden sm:inline" data-id="element-75">|</span>
            <button onClick={() => setActiveModal('cookies')} className="hover:text-white transition-colors" data-id="element-76">
              Cookies
            </button>
            <span className="hidden sm:inline" data-id="element-77">|</span>
            <button onClick={() => setActiveModal('reembolsos')} className="hover:text-white transition-colors" data-id="element-78">
              Reembolsos y devoluciones
            </button>
          </div>
          <p className="text-center" data-id="element-79">
            © {new Date().getFullYear()} Desconexión Emocional. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <PopNotification data-id="element-80" />

      <LegalModal isOpen={activeModal !== null} onClose={() => setActiveModal(null)} title={getModalTitle()} content={renderModalContent()} data-id="element-81" />
    </div>;
}